module.exports = __webpack_public_path__ + "img/model_60.cee74449.jpg";